




























































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import Score from '@/evaluations/entities/score'

@Component
export default class ScoreTable extends Vue {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public items!: Score[]

  private get headers() {
    return [
      {
        text: '',
        value: 'action',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
      {
        text: this.$tc('common.name.full'),
        value: 'name',
        sortable: true,
      },
      {
        text: this.$tc('common.email'),
        value: 'email',
        sortable: true,
      },
      {
        text: this.$tc('evaluations.models.score.target'),
        value: 'target',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.total'),
        value: 'total',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.netTotal'),
        value: 'netTotal',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.bonus'),
        value: 'bonus',
        sortable: true,
        align: 'end',
      },
      {
        text: this.$tc('evaluations.models.score.discrepancy'),
        value: 'discrepancy',
        sortable: true,
        align: 'end',
      },
      {
        text: '',
        value: 'detail',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
    ]
  }
}
